export const actionTypes = {
    GET_CONNECTION_HISTORY_ASSET: 'powertrainTools/gatewayManagement/GET_CONNECTION_HISTORY_ASSET',
    GET_RSSI_HISTORY: 'powertrainTools/gatewayManagement/GET_RSSI_HISTORY',
    GET_RSSI_HISTORY_SETTINGS: 'powertrainTools/gatewayManagement/GET_RSSI_HISTORY_SETTINGS',
    CLEAR_RSSI_HISTORY: 'powertrainTools/gatewayManagement/CLEAR_RSSI_HISTORY'
};

export const zeroBatteryLevel = 0;
